import * as at from './upload_action_types';
import {constants, utils} from 'src/js/common';
import {addError} from 'src/js/containers/status/status_thunks';
import UploadFetcher from 'src/js/fetchers/upload_fetcher';

const logger = utils.LogUtils.getLogger(
  'UploadActions',
  constants.LIBRARY_NAME
);

export function upload(stateId, requestUrl, data) {
  return (dispatch) => {
    Promise.all([dispatch({type: at.UPLOAD, payload: data, stateId})]).then(
      () =>
        UploadFetcher.upload(requestUrl, {data})
          .then((response) => {
            dispatch({type: at.UPLOAD_SUCCESS, payload: response, stateId});
          })
          .catch((error) => {
            logger.error(`File uploading failed: ${error}`);
            dispatch(addError(error, at.UPLOAD_FAILURE));
            return dispatch({type: at.UPLOAD_FAILURE, payload: error, stateId});
          })
    );
  };
}
